import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import ArrepentimientoPreSolicitudComponente from '../components/ArrepentimientoPreSolicitudComponente';
import { ARREPENTIMIENTO } from '../Constantes';




export const ArrepentimientoPreSolicitud: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={ARREPENTIMIENTO} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Arrepentimiento Pre Solicitud'} ></Title>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <ArrepentimientoPreSolicitudComponente />
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>
                        El click en ENVIAR implicará la aceptación para que sus datos sean enviados al Banco. A la brevedad, recibirá al correo electrónico declarado un link para que pueda ingresar la información necesaria para continuar su requerimiento.<br/>

                        Se recuerda que el trámite puede realizarse a distancia a través del Servicio de Banca Internet Provincia (BIP), sin necesidad de concurrir a la Sucursal. Si desea adherirse a BIP ingrese haciendo <a href='https://www.bancoprovincia.bancainternet.com.ar/spa/' style={{color:"#3c3c3b"}}>click acá</a> 
                         </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>

    )

}



